/**
 * @generated SignedSource<<0048803a8a329eb7af66ac6e779ec456>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditPipelinePageQuery$variables = {
  locator: string;
};
export type EditPipelinePageQuery$data = {
  readonly pipeline: {
    readonly " $fragmentSpreads": FragmentRefs<"EditPipelinePageFragment">;
  } | null | undefined;
};
export type EditPipelinePageQuery = {
  response: EditPipelinePageQuery$data;
  variables: EditPipelinePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locator"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "pipelineLocator",
    "variableName": "locator"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "internalId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditPipelinePageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "PipelineRest",
        "kind": "LinkedField",
        "name": "pipeline",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EditPipelinePageFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "EditPipelinePageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "PipelineRest",
        "kind": "LinkedField",
        "name": "pipeline",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BuildTypeRest",
            "kind": "LinkedField",
            "name": "headBuildType",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectRest",
            "kind": "LinkedField",
            "name": "parentProject",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              (v4/*:: as any*/)
            ],
            "storageKey": null
          },
          (v4/*:: as any*/),
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f734aaa98819fd3112c503c7d826e993",
    "id": null,
    "metadata": {},
    "name": "EditPipelinePageQuery",
    "operationKind": "query",
    "text": "query EditPipelinePageQuery(\n  $locator: String!\n) {\n  pipeline(pipelineLocator: $locator) {\n    ...EditPipelinePageFragment\n    _id\n  }\n}\n\nfragment ConfigurationStorageCanEditFragment on PipelineRest {\n  parentProject {\n    id\n    _id\n  }\n}\n\nfragment ConfigurationStorageSwitchFragment on PipelineRest {\n  ...ConfigurationStorageCanEditFragment\n  parentProject {\n    name\n    _id\n  }\n}\n\nfragment EditPipelineBannerToolbarFragment on PipelineRest {\n  ...EditPipelineConfigurationDialogFragment\n}\n\nfragment EditPipelineConfigurationDialogFragment on PipelineRest {\n  ...ConfigurationStorageCanEditFragment\n  ...ConfigurationStorageSwitchFragment\n}\n\nfragment EditPipelinePageFragment on PipelineRest {\n  headBuildType {\n    ...pipelineHeadBuildTypeFragment\n    _id\n  }\n  parentProject {\n    id\n    _id\n  }\n  internalId\n  ...EditPipelineConfigurationDialogFragment\n  ...SettingsSidebarContentFragment\n  ...EditPipelineBannerToolbarFragment\n}\n\nfragment JobSettingsSidebarFragment on BuildTypeRest {\n  ...pipelineHeadBuildTypeFragment\n  ...TimeBadgeFragment\n}\n\nfragment PipelineRepositorySidebarFragment on PipelineRest {\n  parentProject {\n    ...pipelineParentProjectFragment\n    _id\n  }\n  ...ConfigurationStorageSwitchFragment\n}\n\nfragment SettingsSidebarContentFragment on PipelineRest {\n  ...PipelineRepositorySidebarFragment\n  parentProject {\n    ...pipelineParentProjectFragment\n    _id\n  }\n  headBuildType {\n    ...pipelineHeadBuildTypeFragment\n    ...JobSettingsSidebarFragment\n    _id\n  }\n}\n\nfragment TimeBadgeFragment on BuildTypeRest {\n  internalId\n  id\n}\n\nfragment pipelineHeadBuildTypeFragment on BuildTypeRest {\n  id\n}\n\nfragment pipelineParentProjectFragment on ProjectRest {\n  id\n  internalId\n}\n"
  }
};
})();

(node as any).hash = "bfbaf1234e67252c90caa6fce0b486c8";

export default node;
